import React, { Component } from 'react';
import {
	IUserDetailProps,
	IUserDetailState,
} from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import LabelledInput from '../App/styledComponents/LabelledInput';
import ButtonRaised from '@kurtosys/ksys-app-components/dist/components/base/ButtonRaised';
import ErrorMessage from '../App/styledComponents/ErrorMessage';
import SuccessMessage from '../App/styledComponents/SuccessMessage';
import { UserDetailStore } from './stores/UserDetailStore';
import { ActionTiles } from '../App/models/ActionTiles';

@inject('appStore', 'userDetailStore', 'messageStore')
@observer
export class UserDetail extends Component<IUserDetailProps, IUserDetailState> {
	static configurationKey: 'userDetail' = 'userDetail';
	static styleKey: 'userDetail' = 'userDetail';
	constructor(props: IUserDetailProps) {
		super(props);
	}
	render() {
		const { className, userDetailStore, messageStore, appStore } = this.props;
		const { componentKey } = UserDetailStore;

		if (!userDetailStore || !messageStore || !appStore) {
			return null;
		}

		if (!appStore.isActionEnabled(ActionTiles.USER_DETAILS)) {
			return null;
		}

		const { userDetailCardProps } = appStore;
		const { nameLabelledInputProps, emailLabelledInputProps, onSubmitRequestSaveUserDetail, saveUserDetailButtonText, hasValidInputs } = userDetailStore;

		return (
			<Wrapper className={ className } { ...userDetailCardProps }>
				<LabelledInput
					data-qa-ref="userDetailNameField"
					{ ...nameLabelledInputProps }
				/>
				<LabelledInput
					data-qa-ref="userDetailEmailField"
					{ ...emailLabelledInputProps }
				/>
				<ErrorMessage data-qa-ref="userDetailError" >
					{ messageStore.errorTexts.get(componentKey) }
				</ErrorMessage>
				<SuccessMessage data-qa-ref="userDetailInfo">
					{ messageStore.infoTexts.get(componentKey) }
				</SuccessMessage>
				<ButtonRaised
					data-qa-ref="userDetailSaveButton"
					onClick={ onSubmitRequestSaveUserDetail }
					disabled={ !hasValidInputs }
				>
					{ saveUserDetailButtonText }
				</ButtonRaised>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(UserDetail, 'userDetail');

